import { render, staticRenderFns } from "./StudentDocuments.vue?vue&type=template&id=2665c0d0&scoped=true&"
import script from "./StudentDocuments.vue?vue&type=script&lang=js&"
export * from "./StudentDocuments.vue?vue&type=script&lang=js&"
import style0 from "./StudentDocuments.vue?vue&type=style&index=0&id=2665c0d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2665c0d0",
  null
  
)

export default component.exports